import { useEffect } from "react";
import type { Blocker } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from "../../ui/alert-dialog";

interface Props {
  blocker: Blocker;
  isBlocking: boolean;
  pendingNavAction: (() => void) | null;
  onDismissPendingNav: () => void;
}

export function VerificationBlockerModal({
  blocker,
  isBlocking,
  pendingNavAction,
  onDismissPendingNav,
}: Props) {
  // Auto-reset the blocker if the blocking condition clears while blocked
  useEffect(() => {
    if (!isBlocking && blocker.state === "blocked") {
      blocker.reset?.();
    }
    if (!isBlocking && pendingNavAction) {
      onDismissPendingNav();
    }
  }, [isBlocking, blocker, pendingNavAction, onDismissPendingNav]);

  // Show for either URL-based blocking (useBlocker) or state-based blocking (pending action)
  const isOpen = blocker.state === "blocked" || pendingNavAction !== null;
  if (!isOpen) return null;

  const handleStay = () => {
    if (blocker.state === "blocked") {
      blocker.reset?.();
    }
    if (pendingNavAction) {
      onDismissPendingNav();
    }
  };

  const handleLeave = () => {
    if (blocker.state === "blocked") {
      blocker.proceed?.();
    }
    if (pendingNavAction) {
      pendingNavAction();
      onDismissPendingNav();
    }
  };

  return (
    <AlertDialog open>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Verificacion en progreso</AlertDialogTitle>
          <AlertDialogDescription>
            La verificacion de tu documento esta en proceso. Si sales ahora, es
            posible que necesites reiniciar el proceso.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleStay}>
            Quedarme
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleLeave}
            className="bg-red-600 hover:bg-red-700"
          >
            Salir
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
